import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Subject, Observable } from "rxjs";
import { EntityService, RequireMatch, GroupedEntity } from "../../../core";
import { startWith, map } from "rxjs/operators";
import { GroupedEntityService } from "../../../core/services/configuration/grouped-entity.service";

@Component({
  standalone: false,
  selector: "app-group-name-filter",
  templateUrl: "./group-name-filter.component.html",
  styleUrls: ["./group-name-filter.component.scss"],
})
export class GroupNameFilterComponent implements OnInit {
  @Input() placeholder: string = "Agrupación de entidad";
  @Input() isRequired: boolean = false;
  @Input() listByDefault: boolean = false;
  @Input() propertyToEmit: string;
  @Input() selectedGroupName: string;
  @Output() onSelectGroupName = new EventEmitter<any>();
  @Output() onResetGroupName = new EventEmitter<boolean>();
  formIsEnabled: boolean = true;
  groupNameList: GroupedEntity[] = [];
  groupNameAutocompleteList: Observable<any[]>;
  private onDestroy$: Subject<void> = new Subject<void>();
  groupNameFilter: FormControl = new FormControl();
  private initializedWithSelectedValue = false;

  constructor(private groupedEntityService: GroupedEntityService,
    private cdr: ChangeDetectorRef
  ) {
    this.groupNameFilter.setValidators(RequireMatch);
  }

  ngOnInit() {
    this.setRequiredInput();
    if (this.listByDefault) {
      this.getGroupNameList();
    }
  }

  ngOnChanges() {
    if (this.selectedGroupName && this.groupNameList.length > 0 && !this.initializedWithSelectedValue) {
      this.setSelectedGroupName();
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  setRequiredInput() {
    if (this.isRequired) {
      this.groupNameFilter.setValidators([Validators.required, RequireMatch]);
      this.groupNameFilter.updateValueAndValidity();
    }
  }

  getGroupNameList() {
    if (this.groupNameList.length > 0) {
      this.showGroupName();
      if (this.selectedGroupName && !this.initializedWithSelectedValue) {
        this.setSelectedGroupName();
      }
      return;
    }

    this.groupedEntityService
      .findGroupedEntityByFilters()
      .subscribe((response: GroupedEntity[]) => {
        if (response && response.length > 0) {
          this.groupNameList = this.mapGroupNameByEntityCode(response);
          this.showGroupName();

          if (this.selectedGroupName && !this.initializedWithSelectedValue) {
            this.setSelectedGroupName();
          }
        }
      });
  }

  setSelectedGroupName() {
    if (this.selectedGroupName && this.groupNameList.length > 0) {
      const selectedGroup = this.groupNameList.find(group =>
        group.groupName === this.selectedGroupName
      );

      if (selectedGroup) {
        this.groupNameFilter.setValue(selectedGroup);
        this.initializedWithSelectedValue = true;
      }
    }
  }

  mapGroupNameByEntityCode(groupNameList: GroupedEntity[]): GroupedEntity[] {
    return groupNameList.map((groupName:any) => {
        groupName.entityCodesList = groupName.entityCodes.split(',');
        return groupName;
      });
  }

  displayFnGroupName(entityGroup): string {
    return entityGroup
      ? entityGroup.groupName
        ? entityGroup.groupName
        : entityGroup
      : null;
  }

  showGroupName() {
    this.groupNameAutocompleteList = this.groupNameFilter.valueChanges.pipe(
      startWith(""),
      map((value) =>
        !value || typeof value === "string" ? value : value.groupName
      ),
      map((value) =>
        value ? this.filterGroupName(value) : this.groupNameList.slice()
      )
    );
  }

  filterGroupName(value) {
    const filterValue = value.toLowerCase();
    return this.groupNameList.filter(
      (item) =>
        item.groupName.toString().toLowerCase().indexOf(filterValue) >= 0
    );
  }

  cleanGroupName() {
    this.groupNameFilter.setValue(null);
    this.showGroupName();
    this.initializedWithSelectedValue = false;
    this.onResetGroupName.emit(true);
  }

  changeSelectGroupName() {
    this.onSelectGroupName.emit(this.propertyToEmit? this.groupNameFilter.value[this.propertyToEmit] : this.groupNameFilter.value.groupName);
  }

  disableForm() {
    this.groupNameFilter.disable();
    this.formIsEnabled = false;
  }

  validateContent() {
    if (!this.groupNameFilter.value) {
      this.cleanGroupName();
    }
  }
}
